
import Hex from "./HEX.vue";
import RGB from "./RGB.vue";

export default {
  name: "Preview",

  props: {
    red: Number,
    green: Number,
    blue: Number,
    alpha: Number,
    updateColor: Function,
    disabled: Boolean
  },

  components: {
    Hex,
    RGB
  }
};
